import { ReactNode } from "react";
import { PuckCompanyScoreProvider } from "../contexts/PuckCompanyScoreContext";
import { PuckActionPlanProvider } from "../contexts/PuckActionPlanContext";
import { CompanyMetadataProvider } from "src/context/Company/Metadata/provider";
import { useCompanyMetadata } from "src/context/Company/Metadata/useCompanyMetadata";
import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { PuckScoreDetailProvider } from "../contexts/PuckScoreDetailContext";
import { StrategyProvider } from "src/context/Strategy/provider";
import { EntityScoresProvider } from "src/context/Scores/provider";

export type PuckDataProviderProps = {
    children: ReactNode;
};

export const PuckDataProvider = (props: PuckDataProviderProps) => {
    const { children } = props;
    const foodpilotContext = useFoodpilotContext();
    const companyId = foodpilotContext?.selectedCompany?.id;
    const hasCompanyScores = foodpilotContext.getScoresByType("company").length > 0;

    if (!companyId) {
        return (
            <PuckScoreDetailProvider>
                <PuckCompanyScoreProvider>
                    <PuckActionPlanProvider>{children}</PuckActionPlanProvider>
                </PuckCompanyScoreProvider>
            </PuckScoreDetailProvider>
        );
    }

    return (
        <CompanyMetadataProvider companyId={companyId}>
            <StrategyProvider>
                <PuckScoreDetailProvider>
                    <PuckCompanyScoreProvider>
                        <PuckDataProviderWithCompany hasCompanyScores={hasCompanyScores}>
                            {children}
                        </PuckDataProviderWithCompany>
                    </PuckCompanyScoreProvider>
                </PuckScoreDetailProvider>
            </StrategyProvider>
        </CompanyMetadataProvider>
    );
};

const PuckDataProviderWithCompany = (props: { children: ReactNode; hasCompanyScores: boolean }) => {
    const { children, hasCompanyScores } = props;
    const { ssqVersion } = useCompanyMetadata();

    if (!hasCompanyScores) {
        return <PuckActionPlanProvider>{children}</PuckActionPlanProvider>;
    }

    return (
        <EntityScoresProvider entity="company" ssq={ssqVersion?.ssq}>
            <PuckActionPlanProvider>{children}</PuckActionPlanProvider>
        </EntityScoresProvider>
    );
};
